module.exports = __webpack_public_path__ + "static/media/N. Lenore, Willits, CA (2 Buildings)3.e55a5e73.jpg";